import { HOURS, MINUTES, TOTAL_LENGTH_OF_LONG_LIST } from './constants';

export const generateLongList = ({ isHour }: { isHour: boolean }) => {
  const singleList = isHour ? HOURS : MINUTES;
  const longList: number[][] = [];
  for (let i = 0; i < TOTAL_LENGTH_OF_LONG_LIST; i++) {
    longList.push(singleList);
  }
  return longList.flat();
};
